export function buildSectionSeoTitle(value, section) {
  const title = String(value || "").replace(/\s+/g, " ").trim();
  const normalizedSection = String(section || "").replace(/\s+/g, " ").trim();

  if (!title) {
    return normalizedSection ? `${normalizedSection} | FPEP Bar` : "FPEP Bar";
  }

  if (/\bfpep\s+bar\b/i.test(title)) {
    return title;
  }

  if (normalizedSection && title.toLowerCase().endsWith(`| ${normalizedSection.toLowerCase()}`)) {
    return `${title} | FPEP Bar`;
  }

  return normalizedSection
    ? `${title} | ${normalizedSection} | FPEP Bar`
    : `${title} | FPEP Bar`;
}
